import { Button, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import { OpenInNewTabButton, RemoveButton, SectionHeading } from 'ContentItemEditor';
import { useFieldArray, useFormContext } from 'FrontRoyalReactHookForm';
import { TextField } from 'FrontRoyalMaterialUiForm';
import ReorderButtons from './ReorderButtons';
import { type StreamFormValues } from './StreamEditor.types';

// Links to somewhere else, rather than files. An admin types both the title and the url.
export default function ResourceLinksSection() {
    const { control, watch } = useFormContext<StreamFormValues>();
    const { fields, append, remove, move } = useFieldArray({ control, name: 'resource_links' });
    const links = watch('resource_links');

    return (
        <Stack spacing={2}>
            <SectionHeading>Links</SectionHeading>

            {fields.map((field, index) => (
                <Stack key={field.id} direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                    <TextField
                        name={`resource_links.${index}.title`}
                        label="Title for display"
                        fullWidth
                        slotProps={{ htmlInput: { dir: 'auto' } }}
                    />

                    <TextField name={`resource_links.${index}.url`} label="Full URL" fullWidth />

                    <Stack direction="row" sx={{ alignItems: 'center' }}>
                        <OpenInNewTabButton
                            href={links?.[index]?.url || ''}
                            label="Test this link"
                            disabled={!links?.[index]?.url}
                        />

                        <ReorderButtons index={index} count={fields.length} label="this link" onMove={move} />

                        <RemoveButton label="Remove this link" onClick={() => remove(index)} />
                    </Stack>
                </Stack>
            ))}

            <Button
                name="add_resource_links"
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={() => append({ title: '', url: '' })}
                sx={{ alignSelf: 'flex-start' }}
            >
                Add Link
            </Button>
        </Stack>
    );
}
